import React from 'react';
import { GoogleIcon, KivlopeLogo, SealedEnvelopeIcon } from '../components/Icons';

const LoginScreen = ({ onLogin, onInfoClick }) => (
  <div className="min-h-screen flex flex-col items-center justify-center text-center p-4 overflow-hidden relative bg-gradient-to-b from-[#121212] to-black">
    <div className="absolute inset-0 z-0">
      <div className="absolute top-0 left-0 w-full h-full bg-radial-gradient from-transparent via-transparent to-[#121212]"></div>
    </div>
    <div className="z-10 flex flex-col items-center">
      <KivlopeLogo size={120} />
      <h1 className="text-5xl md:text-7xl font-bold text-[#D4AF37] mt-4 font-serif">kivlope</h1>
      <p className="text-lg text-[#A0A0A0] mt-4 mb-12 max-w-xl">Some things are worth the wait. Seal your memories, messages, and promises for the future.</p>
      <button onClick={onLogin} className="bg-white text-[#121212] font-bold py-3 px-8 rounded-lg text-lg flex items-center transition duration-300 shadow-lg hover:shadow-[#D4AF37]/30 transform hover:scale-105">
        <GoogleIcon />
        Sign In with Google
      </button>
      <button onClick={onInfoClick} className="mt-8 text-[#A0A0A0] hover:text-[#D4AF37] underline transition-colors">
        Learn More about kivlope
      </button>
    </div>
  </div>
);

export default LoginScreen;
